module.exports = __webpack_public_path__ + "img/1997-Aktiengesellschaft-Pirker-Haberfellner-Kainz.2ea73f17.jpg";